export default class CancelAppointmentError extends Error {
    constructor() {
        super("Unable to cancel appointment");
    }
}
